import { Popconfirm, Popover, Table } from "antd";
import React from "react";
import AccessTo from "../../../../../components/is-show/AccessTo";
import { CM, FL, ML, PA, PFA, SM } from "../../../../router/AddRoutesJson";
import { VscEye, VscTrash } from "react-icons/vsc";
import { FiEdit } from "react-icons/fi";
import { Link } from "react-router-dom";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { REMOVE_LOCAL_STORAGE_BY_KEY } from "../../../../../helpers/localStorage";
import { CiCirclePlus } from "react-icons/ci";
const staticData = [
  // {
  //   key: "1",
  //   name: "Project Alpha",
  //   owner: "John Doe",
  //   description:
  //     "This is the description of Project Alpha, which is a long text.",
  // },
  // {
  //   key: "2",
  //   name: "Project Beta",
  //   owner: "Jane Smith",
  //   description: "This is the description of Project Beta.",
  // },
  // {
  //   key: "3",
  //   name: "Project Gamma",
  //   owner: "Alice Johnson",
  //   description:
  //     "This is the description of Project Gamma, which is a long text.",
  // },
];
// ----------------------JSX----------------
function IndexOfML() {
  const columns = [
    {
      title: "Project Title",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Project Owner",
      dataIndex: "owner",
      key: "owner",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (para) => (
        <div>
          <Popover content={<>{para}</>} title="Description">
            {para?.substring(0, 18)}
            {para?.length > 18 ? "...." : ""}
          </Popover>
        </div>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, data) => (
        <div className="flex">
          <AccessTo role={[PFA, ML, FL, CM, SM]}>
            <Link to={`/preview-fl-project/${data?.key}`} className="h-0">
              <button className="mx-2">
                <VscEye size={16} color="#4ea927" className="opacity-[0.8]" />
              </button>
            </Link>
          </AccessTo>
          <AccessTo role={[PA]}>
            <Link to={`/preview-fl-project/${data?.key}`} className="h-0">
              <button className="mx-2">
                <FiEdit size={16} color="#4ea927" className="opacity-[0.8]" />
              </button>
            </Link>
            <button>
              <Popconfirm
                title="Are you sure?"
                description="Once deleted, it cannot be recovered."
                onConfirm={() => console.log("Delete:", data.key)}
                icon={<QuestionCircleOutlined color={"red"} />}
              >
                <VscTrash size={18} color="red" />
              </Popconfirm>
            </button>
          </AccessTo>
        </div>
      ),
    },
  ];

  return (
    <div className="crd-wrap">
      <AccessTo role={[PA]}>
        <div className="flex justify-end">
          <Link to="/create-ml-project">
            <button className="crt-usr-btn mb-4">
              <CiCirclePlus size={17} className="me-1 stroke-[0.6px]" />
              Create Project
            </button>
          </Link>
        </div>
      </AccessTo>
      <Table
        className=" user-table-theme"
        columns={columns}
        dataSource={staticData}
        pagination={{ pageSize: 7 }}
      />
    </div>
  );
}

export default IndexOfML;
